exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".carousel-skeleton{margin-top:8px}.carousel-skeleton__header{line-height:48px;font-size:28px;width:33%;margin-bottom:24px}.carousel-skeleton__body{margin:8px 0;width:100%}.carousel-skeleton__item{display:flex;flex-direction:column;align-items:center}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};